export const ALLOWED_STATES = [
	'magic-link',
	'direct-login'
];

export enum StorageKeys {
	idToken = 'bl#idToken',
	refreshToken = 'bl#refreshToken',
	accessToken = 'bl#accessToken',
	authState = 'bl#authState',
	redirectCount = 'bl#redirectCount'
}

export enum QueryParams {
	code = 'code',
	state = 'state',
	bl = 'bl',
}

export enum Cookies {
	refreshToken = 'refreshToken',
	activityTimeout = 'activityTimeout'
}